/*------------------------------------------------------------------------
Used to scale video embeds to fill their container and become a background
------------------------------------------------------------------------*/

export default class BackgroundVideo {
  constructor(video) {
    // The video / iframe element
    this.element = video;
  }

  resize() {
    if (this.element.parentNode) {
      // Initialise the size as full width
      this.element.style.width = '100%';
      this.element.style.height = `${Math.round(this.element.clientWidth * 0.5625)}px`;

      // Then check it is big enough
      if (this.element.clientHeight < this.element.parentNode.clientHeight) {
        // If not then make it taller and wider!
        this.element.style.height = '100%';
        this.element.style.width = `${Math.round(this.element.clientHeight * 1.7777777778)}px`;
      }
    }
  }
}